const development_tenant = {
    notification: 'Du befindest dich im Entwicklungsmodus',
};
export default Object.freeze(development_tenant);
